import { render, staticRenderFns } from "./SignQuick.vue?vue&type=template&id=1bff6b3f&scoped=true"
import script from "./SignQuick.vue?vue&type=script&lang=js"
export * from "./SignQuick.vue?vue&type=script&lang=js"
import style0 from "./SignQuick.vue?vue&type=style&index=0&id=1bff6b3f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bff6b3f",
  null
  
)

export default component.exports